// document.addEventListener("DOMContentLoaded", pdpGalleryModalInit);

// document.addEventListener("variantChange", pdpGalleryModalInit);

// function pdpGalleryModalInit() {
//   const modal = document.getElementById("product-gallery-modal");
//   const closeBtn = modal.querySelector(".gallery-modal__close");
//   const overlay = modal.querySelector(".gallery-modal__overlay");
//   const galleryImages = document.querySelectorAll(".product-single__main-gallery img");

//   const isMobile = () => window.innerWidth <= 768;

//   const thumbSwiper = new Swiper(".product-gallery-thumbs", {
//     slidesPerView: 'auto',
//     watchSlidesProgress: true,
//     slideToClickedSlide: true,
//     spaceBetween: 10,
//     navigation: {
//       nextEl: ".product-gallery-thumbs-container .swiper-button-next.arrow-next",
//       prevEl: ".product-gallery-thumbs-container .swiper-button-prev.arrow-prev",
//     },
//     breakpoints: {
//       // when window width is >= 769px
//       769: {
//         spaceBetween: 20
//       }
//     }
//   });

//   const swiperModal = new Swiper(".gallery-modal__swiper", {
//     spaceBetween: 30,
//     // simulateTouch: false,
//     slideToClickedSlide: true,
//     // shortSwipes: false,
//     navigation: {
//       nextEl: ".gallery-modal__swiper .swiper-button-next.arrow-next",
//       prevEl: ".gallery-modal__swiper .swiper-button-prev.arrow-prev",
//     },
//     thumbs: {
//       swiper: thumbSwiper,
//     }
//   });
  
//   // Show modal on image click
//   galleryImages.forEach((img, index) => {
//     // if(isMobile() !== true) return
//     img.addEventListener("click", (e) => {
//       modal.classList.remove("hidden");

//       console.log("Swiper Modal:", swiperModal);
//       console.log("Target", e.target);
//       console.log('Target Index', e.target.closest('.swiper-slide').getAttribute('data-swiper-slide-index'));

      
//       if(isMobile()) {
//         let slideToIndex = index - 2;
//         swiperModal.slideTo(slideToIndex); // Jump to correct image 
//       } else {
//         let slideToIndex = index - 1;
//         swiperModal.slideTo(slideToIndex); // Jump to correct image
//       }
//     });
//   });

//   let desktopMainImage = document.querySelector('.product-single__main-image img');
//   desktopMainImage.addEventListener("click", (e) => {
//     modal.classList.remove("hidden");
//     // let slideToIndex = index - 1;
//     swiperModal.slideTo(0); // Jump to correct image
//   });

//   // Close modal
//   [closeBtn, overlay].forEach(el =>
//     el.addEventListener("click", () => modal.classList.add("hidden"))
//   );

//   document.addEventListener("keydown", (e) => {
//     if (e.key === "Escape") modal.classList.add("hidden");
//   });


//   // Zoom behavior  

//   const zoomContainers = document.querySelectorAll('.zoom-container');

//   const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

//   if (!isTouchDevice) {

//     zoomContainers.forEach(container => {
//       const img = container.querySelector('img');
//       let isZoomed = false;

//       img.addEventListener("click", (e) => {
//         isZoomed = !isZoomed;
//         container.classList.toggle("zoomed", isZoomed);

//         if (!isZoomed) {
//           img.style.transform = "scale(1)";
//           img.style.transformOrigin = "center center";
//         } else {
//           updateZoom(e);
//         }
//       });

//       container.addEventListener("mousemove", (e) => {
//         if (!isZoomed) return;
//         updateZoom(e);
//       });

//       // const updateZoom = (e) => {
//       //   const scale = 1.8;
//       //   const rect = container.getBoundingClientRect();
//       //   const imgRect = img.getBoundingClientRect();
//       //   // const x = ((e.clientX - rect.left) / rect.width) * 100;
//       //   // const y = ((e.clientY - rect.top) / rect.height) * 100;

//       //   // img.style.transformOrigin = `${x}% ${y}%`;
//       //   // img.style.transform = "scale(2.5)";

//       //   let x = ((e.clientX - rect.left)   / rect.width)  * 100;
//       //   let yDiff = imgRect.height - rect.height;
//       //   let y = ((e.clientY - rect.top) / rect.height) * 100;

//       //   // compute the clamp bounds so the scaled image always covers the container
//       //   // 50/s says how far from the edges the origin can go
//       //   const minPercent = 0 / scale;      // e.g. at scale=2.5 ⇒ 20%
//       //   const maxPercent = 135; // e.g. 80%

//       //   // clamp
//       //   x = Math.min(Math.max(x, minPercent), maxPercent);
//       //   // y = Math.min(Math.max(y, minPercent), maxPercent);

//       //   // apply
//       //   img.style.transformOrigin = `${x}% ${y}%`;
//       //   img.style.transform = `scale(${scale})`;
//       // };

//         function updateZoom(e) {
//         // use clientWidth/Height so we don’t accidentally include borders/paddings
//         const scale = 1.8;
//         const W = container.clientWidth;
//         const H = container.clientHeight;
//         const rect = container.getBoundingClientRect();

//         // raw pointer % inside container
//         let x = ((e.clientX - rect.left) / W) * 100;
//         let y = ((e.clientY - rect.top)  / H) * 100;

//         // clamp bounds: (50/scale)% … (100 – 50/scale)%
//         const edge = 50 / scale;
//         const minP = 0;
//         const maxP = 100;

//         x = Math.max(minP, Math.min(x, maxP));
//         y = Math.max(minP, Math.min(y, maxP));

//         img.style.transform = `scale(${scale}) translate(0,0)`; 
//         img.style.transformOrigin = `${x}% ${y}%`;
//       }
//     });


//     // Optional ESC key to exit zoom
//     document.addEventListener("keydown", (e) => {
//       if (e.key === "Escape") {
//         document.querySelectorAll(".zoom-container.zoomed").forEach(container => {
//           container.classList.remove("zoomed");
//           const img = container.querySelector("img");
//           img.style.transform = "scale(1)";
//           img.style.transformOrigin = "center center";
//         });
//       }
//     });
//   }



//   const containers = document.querySelectorAll('.zoom-container');

//   containers.forEach(container => {
//     const img = container.querySelector('img');
//     const originalImgHeight = img.getBoundingClientRect().height;

//     let scale = 1;
//     let lastScale = 1;
//     let startDistance = 0;
//     let origin = { x: 0, y: 0 };

//     let panX = 0, panY = 0;
//     let startPan = { x: 0, y: 0 };
//     let startTouch = { x: 0, y: 0 };
//     let isPanning = false;
//     let isZooming = false;

//     function updateTransform() {     
//       clamp();

//       // console.log('PanX:' + panX);
//       // console.log('PanY:' + panY);

//       if(scale > 2.5) {
//         scale = 2.5;
//       }

//       img.style.transform = `translate3d(${panX}px, ${panY}px, 0px) scale(${scale})`;
//       // img.style.transform = `scale(${scale})`;

//     }

//     function clamp() {
//       const containerRect = container.getBoundingClientRect();
//       const imgRect = img.getBoundingClientRect();

//       const scaledW = imgRect.width;
//       const scaledH = imgRect.height;
//       const containerW = containerRect.width;
//       const containerH = containerRect.height;

//       // const panOffsetY = (containerH - originalImgHeight) * 0.5;

//       let distanceX = (scaledW - containerW) * 0.5;
//       let maxX = -(distanceX);

//       if(panX > 0) {
//         panX = Math.min(panX, distanceX);
//       }

//       if(panX < 0) {
//         panX = Math.max(panX, maxX)
//       }

//       console.log("panx: " + panX);
//       console.log("distanceX: " + distanceX);
//       console.log("maxX: " + maxX);

//       let distanceY = (scaledH - containerH) * 0.5;
//       distanceY = distanceY;
//       let maxY = -(distanceY);

//       if(panY > 0) {
//         panY = Math.min(panY, distanceY);
//       }

//       if(panY < 0) {
//         panY = Math.max(panY, maxY)
//       }

//       console.log("panY: " + panY);
//       console.log("distanceY: " + distanceY);
//       console.log("maxY: " + maxY);

//     }

//     // function updateOrigin() {

//     //   img.style.transformOrigin = `${panX}px ${panY}px`;
//     // }

//     container.addEventListener("touchstart", (e) => {
//       if(scale > 1) {
//         container.classList.add('swiper-no-swiping');
//       }
//       if (e.touches.length === 2) {
//         isZooming = true;
//         startDistance = getDistance(e.touches[0], e.touches[1]);
//         origin = getMidpoint(e.touches[0], e.touches[1]);
//         lastScale = scale;
//       } else if (e.touches.length === 1 && scale > 1) {
//         isPanning = true;
//         startTouch = {
//           x: e.touches[0].pageX,
//           y: e.touches[0].pageY,
//         };
//         startPan = { x: panX, y: panY };
//       }
//     });

//     container.addEventListener("touchmove", (e) => {
//       if (isZooming && e.touches.length === 2) {
//         e.preventDefault();
//         const newDistance = getDistance(e.touches[0], e.touches[1]);
//         scale = lastScale * (newDistance / startDistance);
//         scale = Math.min(Math.max(1, scale), 4); // Clamp

//         const rect = img.getBoundingClientRect();
//         const originX = ((origin.x - rect.left) / rect.width) * 100;
//         const originY = ((origin.y - rect.top) / rect.height) * 100;

//         // img.style.transformOrigin = `${originX}% ${originY}%`;
//         updateTransform();
//       }

//       if (isPanning && e.touches.length === 1) {
//         e.preventDefault();
//         const deltaX = e.touches[0].pageX - startTouch.x;
//         const deltaY = e.touches[0].pageY - startTouch.y;
//         panX = startPan.x + deltaX;
//         panY = startPan.y + deltaY;
//         updateTransform();
//       }
//     });

//     container.addEventListener("touchend", (e) => {
//       if (e.touches.length < 2) isZooming = false;
//       if (e.touches.length === 0) isPanning = false;

//       if (scale <= 1.05) {
//         container.classList.remove('swiper-no-swiping');
//         scale = 1;
//         panX = 0;
//         panY = 0;
//         updateTransform();
//       }
//     });

//     function getDistance(t1, t2) {
//       return Math.hypot(t2.pageX - t1.pageX, t2.pageY - t1.pageY);
//     }

//     function getMidpoint(t1, t2) {
//       return {
//         x: (t1.pageX + t2.pageX) / 2,
//         y: (t1.pageY + t2.pageY) / 2,
//       };
//     }
//   });

// }

window.variantChanged = false;

class GalleryModalSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.closeBtn = this.querySelector(".accordion-toggle");
    // this.content = this.querySelector(".accordion-section__content");

    // if (!this.toggleBtn || !this.content) return;

    // this.toggleBtn.addEventListener("click", () => this.toggleAccordion());

    // this.variantChanged = false;

    document.addEventListener("DOMContentLoaded", this.pdpGalleryModalInit());

    document.addEventListener("loopVariantChange", function() {
      window.variantChanged = true;
    });
  }

  pdpGalleryModalInit() {
    const modal = this.querySelector('#product-gallery-modal');
    const closeBtn = this.querySelector(".gallery-modal__close");
    const overlay = this.querySelector(".gallery-modal__overlay");
    const galleryImages = document.querySelectorAll(".product-single__main-gallery img");
    const self  = this;

    const isMobile = () => window.innerWidth <= 768;

    const thumbSwiper = new Swiper(".product-gallery-thumbs", {
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".product-gallery-thumbs-container .swiper-button-next.arrow-next",
        prevEl: ".product-gallery-thumbs-container .swiper-button-prev.arrow-prev",
      },
      breakpoints: {
        // when window width is >= 769px
        769: {
          spaceBetween: 20
        }
      }
    });

    const swiperModal = new Swiper(".gallery-modal__swiper", {
      spaceBetween: 30,
      // simulateTouch: false,
      slideToClickedSlide: true,
      // shortSwipes: false,
      navigation: {
        nextEl: ".gallery-modal__swiper .swiper-button-next.arrow-next",
        prevEl: ".gallery-modal__swiper .swiper-button-prev.arrow-prev",
      },
      thumbs: {
        swiper: thumbSwiper,
      }
    });
    

    // Show modal on image click
    for(let i = 0; i < galleryImages.length; i++) {
      // if(isMobile() !== true) return
      let catalogueImg = false;
      if(galleryImages[i].closest('.main-gallery__slide').classList.contains('.main-gallery__catalogue-image')) {
        catalogueImg = true;
      }

      galleryImages[i].addEventListener("click", (e) => {
        modal.classList.remove("hidden");
        
        if(isMobile()) {
          let slideToIndex = i;
          if(window.variantChanged) {
            slideToIndex = slideToIndex - 2;
          }
          swiperModal.slideTo(slideToIndex); // Jump to correct image 
        } else {
          let slideToIndex = i;
          if(window.variantChanged) {
            slideToIndex = slideToIndex - 1;
          }
          swiperModal.slideTo(slideToIndex); // Jump to correct image
        }
      });

    }

    let desktopMainImage = document.querySelector('.product-single__main-image img');
    desktopMainImage.addEventListener("click", (e) => {
      modal.classList.remove("hidden");
      // let slideToIndex = index - 1;
      swiperModal.slideTo(0); // Jump to correct image
    });

    // Close modal
    [closeBtn, overlay].forEach(el =>
      el.addEventListener("click", () => modal.classList.add("hidden"))
    );

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") modal.classList.add("hidden");
    });


    // Zoom behavior  

    const zoomContainers = document.querySelectorAll('.zoom-container');

    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    if (!isTouchDevice) {

      zoomContainers.forEach(container => {
        const img = container.querySelector('img');
        let isZoomed = false;

        img.addEventListener("click", (e) => {
          isZoomed = !isZoomed;
          container.classList.toggle("zoomed", isZoomed);

          if (!isZoomed) {
            img.style.transform = "scale(1)";
            img.style.transformOrigin = "center center";
          } else {
            updateZoom(e);
          }
        });

        container.addEventListener("mousemove", (e) => {
          if (!isZoomed) return;
          updateZoom(e);
        });

          function updateZoom(e) {
          // use clientWidth/Height so we don’t accidentally include borders/paddings
          const scale = 1.8;
          const W = container.clientWidth;
          const H = container.clientHeight;
          const rect = container.getBoundingClientRect();

          // raw pointer % inside container
          let x = ((e.clientX - rect.left) / W) * 100;
          let y = ((e.clientY - rect.top)  / H) * 100;

          // clamp bounds: (50/scale)% … (100 – 50/scale)%
          const edge = 50 / scale;
          const minP = 0;
          const maxP = 100;

          x = Math.max(minP, Math.min(x, maxP));
          y = Math.max(minP, Math.min(y, maxP));

          img.style.transform = `scale(${scale}) translate(0,0)`; 
          img.style.transformOrigin = `${x}% ${y}%`;
        }
      });


      // Optional ESC key to exit zoom
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          document.querySelectorAll(".zoom-container.zoomed").forEach(container => {
            container.classList.remove("zoomed");
            const img = container.querySelector("img");
            img.style.transform = "scale(1)";
            img.style.transformOrigin = "center center";
          });
        }
      });
    }



    const containers = document.querySelectorAll('.zoom-container');

    containers.forEach(container => {
      const img = container.querySelector('img');
      const originalImgHeight = img.getBoundingClientRect().height;

      let scale = 1;
      let lastScale = 1;
      let startDistance = 0;
      let origin = { x: 0, y: 0 };

      let panX = 0, panY = 0;
      let startPan = { x: 0, y: 0 };
      let startTouch = { x: 0, y: 0 };
      let isPanning = false;
      let isZooming = false;

      function updateTransform() {     
        clamp();

        // console.log('PanX:' + panX);
        // console.log('PanY:' + panY);

        if(scale > 2.5) {
          scale = 2.5;
        }

        img.style.transform = `translate3d(${panX}px, ${panY}px, 0px) scale(${scale})`;
        // img.style.transform = `scale(${scale})`;

      }

      function clamp() {
        const containerRect = container.getBoundingClientRect();
        const imgRect = img.getBoundingClientRect();

        const scaledW = imgRect.width;
        const scaledH = imgRect.height;
        const containerW = containerRect.width;
        const containerH = containerRect.height;

        // const panOffsetY = (containerH - originalImgHeight) * 0.5;

        let distanceX = (scaledW - containerW) * 0.5;
        let maxX = -(distanceX);

        if(panX > 0) {
          panX = Math.min(panX, distanceX);
        }

        if(panX < 0) {
          panX = Math.max(panX, maxX)
        }

        console.log("panx: " + panX);
        console.log("distanceX: " + distanceX);
        console.log("maxX: " + maxX);

        let distanceY = (scaledH - containerH) * 0.5;
        distanceY = distanceY;
        let maxY = -(distanceY);

        if(panY > 0) {
          panY = Math.min(panY, distanceY);
        }

        if(panY < 0) {
          panY = Math.max(panY, maxY)
        }

        console.log("panY: " + panY);
        console.log("distanceY: " + distanceY);
        console.log("maxY: " + maxY);

      }

      // function updateOrigin() {

      //   img.style.transformOrigin = `${panX}px ${panY}px`;
      // }

      container.addEventListener("touchstart", (e) => {
        if(scale > 1) {
          container.classList.add('swiper-no-swiping');
        }
        if (e.touches.length === 2) {
          isZooming = true;
          startDistance = getDistance(e.touches[0], e.touches[1]);
          origin = getMidpoint(e.touches[0], e.touches[1]);
          lastScale = scale;
        } else if (e.touches.length === 1 && scale > 1) {
          isPanning = true;
          startTouch = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY,
          };
          startPan = { x: panX, y: panY };
        }
      });

      container.addEventListener("touchmove", (e) => {
        if (isZooming && e.touches.length === 2) {
          e.preventDefault();
          const newDistance = getDistance(e.touches[0], e.touches[1]);
          scale = lastScale * (newDistance / startDistance);
          scale = Math.min(Math.max(1, scale), 4); // Clamp

          const rect = img.getBoundingClientRect();
          const originX = ((origin.x - rect.left) / rect.width) * 100;
          const originY = ((origin.y - rect.top) / rect.height) * 100;

          // img.style.transformOrigin = `${originX}% ${originY}%`;
          updateTransform();
        }

        if (isPanning && e.touches.length === 1) {
          e.preventDefault();
          const deltaX = e.touches[0].pageX - startTouch.x;
          const deltaY = e.touches[0].pageY - startTouch.y;
          panX = startPan.x + deltaX;
          panY = startPan.y + deltaY;
          updateTransform();
        }
      });

      container.addEventListener("touchend", (e) => {
        if (e.touches.length < 2) isZooming = false;
        if (e.touches.length === 0) isPanning = false;

        if (scale <= 1.05) {
          container.classList.remove('swiper-no-swiping');
          scale = 1;
          panX = 0;
          panY = 0;
          updateTransform();
        }
      });

      function getDistance(t1, t2) {
        return Math.hypot(t2.pageX - t1.pageX, t2.pageY - t1.pageY);
      }

      function getMidpoint(t1, t2) {
        return {
          x: (t1.pageX + t2.pageX) / 2,
          y: (t1.pageY + t2.pageY) / 2,
        };
      }
    });

  }
}

customElements.define("product-gallery-modal", GalleryModalSection);

